export default function carousel({
                                     minItemWidth = 220,
                                     gap = 16,
                                     minVisible = 2,   // 🔥 ВАЖНО
                                     peek = 0.5
                                 } = {}) {
    return {
        minItemWidth,
        gap,
        minVisible,
        peek,

        itemWidth: minItemWidth,
        canScroll: false,

        recalc() {
            const track = this.$refs.track
            if (!track) return

            const containerWidth = track.clientWidth
            const itemsCount = track.children.length

            // сколько МОЖЕТ влезть
            let visible = Math.floor(
                containerWidth / (this.minItemWidth + this.gap)
            )

            // 🔥 НЕ МЕНЬШЕ minVisible
            visible = Math.max(this.minVisible, visible)

            const divisor = visible + this.peek

            this.itemWidth = Math.floor(
                (containerWidth - this.gap * (visible - 1)) / divisor
            )

            this.$nextTick(() => {
                this.canScroll = itemsCount > visible

                // если скролл не нужен — растягиваем
                if (!this.canScroll && itemsCount > 0) {
                    this.itemWidth = Math.floor(
                        (containerWidth - this.gap * (itemsCount - 1)) / itemsCount
                    )
                }
            })
        },

        next() {
            this.$refs.track.scrollBy({
                left: this.itemWidth + this.gap,
                behavior: 'smooth'
            })
        },

        prev() {
            this.$refs.track.scrollBy({
                left: -(this.itemWidth + this.gap),
                behavior: 'smooth'
            })
        },
        isDragging: false,
        startX: 0,
        scrollLeft: 0,

        startDrag(e) {
            this.isDragging = true
            this.startX = e.pageX || e.touches[0].pageX
            this.scrollLeft = this.$refs.track.scrollLeft
        },

        onDrag(e) {
            if (!this.isDragging) return

            const x = e.pageX || e.touches[0].pageX
            const walk = (x - this.startX) * 1.2

            this.$refs.track.scrollLeft = this.scrollLeft - walk
        },

        stopDrag() {
            this.isDragging = false
        },
    }
}
